import { render, staticRenderFns } from "./PgSetting.vue?vue&type=template&id=7debaaf8&"
import script from "./PgSetting.vue?vue&type=script&lang=ts&"
export * from "./PgSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports